import React from 'react';
import { Warning } from '../../icons';
import {
  WarningBanner,
  WarningContainer,
  IconSizing,
  MainText,
  SecondaryText
} from './GlobalOutageBannertStyles';

export default () => {
  return (
    <WarningBanner>
      <WarningContainer>
        <IconSizing>
          <Warning />
        </IconSizing>
        <div>
          <MainText>
            The site is currently under scheduled maintenance.
          </MainText>
          <SecondaryText>
            Some services may not be fully available at this time. Please check
            back in 24 to 48 hours.
          </SecondaryText>
        </div>
      </WarningContainer>
    </WarningBanner>
  );
};
